import {Model} from "@vuex-orm/core";
import Composition from "@/models/Product/Detail/Composition/Composition";

export default class DiscountProductDetailComposition extends Model {
    static entity = 'productDiscountProductDetailCompositions'

    static primaryKey = ['product_discount_id', 'product_detail_composition_id']

    static fields() {
        return {
            product_discount_id: this.number(null).nullable(),
            product_detail_composition_id: this.number(null).nullable(),
            pax: this.hasOne(Composition, 'id', 'product_detail_composition_id'),
        }
    }
}
